export default __webpack_public_path__ + "static/media/vkpic5.f6403537.png";